var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-small" },
      [
        _c(
          "div",
          { staticClass: "top-btn" },
          [
            _c("router-link", { attrs: { to: { name: "add-profile" } } }, [
              _c(
                "button",
                { staticClass: "main-btn", attrs: { type: "submit" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("btn_add_profile")) + " "),
                  _c("i", { staticClass: "fas fa-plus" }),
                ]
              ),
            ]),
          ],
          1
        ),
        !_vm.loading && _vm.profiles
          ? _c(
              "div",
              { staticClass: "profiles" },
              [
                _vm._l(_vm.profiles, function (profile) {
                  return _c(
                    "div",
                    { staticClass: "profile remove-a" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "edit-profile",
                              params: { id: profile.id },
                            },
                          },
                        },
                        [_c("Profile", { attrs: { profile: profile } })],
                        1
                      ),
                      _c("div", { staticClass: "action-buttons" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end mt-sm-4 mt-2",
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "edit-btn",
                                attrs: {
                                  to: {
                                    name: "edit-profile",
                                    params: { id: profile.id },
                                  },
                                },
                              },
                              [_c("span", { staticClass: "edit-icon" })]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "trash-btn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.remove(profile.id)
                                  },
                                },
                              },
                              [_c("span", { staticClass: "delete-icon" })]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          : [
              _c(
                "div",
                { staticClass: "alert alert-info text-center mt-2 mb-2" },
                [_vm._v(" " + _vm._s(_vm.$t("profiles_no_profile")) + " ")]
              ),
            ],
      ],
      2
    ),
    _c("div", { staticClass: "container pb-4" }, [
      _c(
        "div",
        { staticClass: "bottom-action-button text-center" },
        [
          _c("router-link", { attrs: { to: { name: "add-profile" } } }, [
            _c(
              "button",
              { staticClass: "main-btn", attrs: { type: "submit" } },
              [
                _vm._v(" " + _vm._s(_vm.$t("btn_add_profile")) + " "),
                _c("i", { staticClass: "fas fa-plus" }),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }